import { CircleClockIcon, Work2Icon } from "@cpj-ai/panel-npm-package";
import { AuthAccountOrganizationEmployeeCooperationStatusChoices } from "@graphql/generated";
import { colors } from "@heroui/react";

export const employeeStatusConfig = {
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.ACTIVE]: {
    label: "Active",
    icon: Work2Icon,
    color: "text-green-500",
    iconColor: "#00c951",
  },
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.SUSPENDED]: {
    label: "Suspended",
    icon: CircleClockIcon,
    color: "text-yellow-500",
    iconColor: colors.yellow["500"],
  },
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.FINISHED]: {
    label: "Ended",
    icon: Work2Icon,
    color: "text-red-500",
    iconColor: colors.red["500"],
  },
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.AWAITING]: {
    label: "Awaiting Start",
    icon: CircleClockIcon,
    color: "text-cyan-500",
    iconColor: "#09AACD",
  },
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.FIRED]: {
    label: "Fired",
    icon: CircleClockIcon,
    color: "text-red-500",
    iconColor: colors.red["500"],
  },
  [AuthAccountOrganizationEmployeeCooperationStatusChoices.RESIGNED]: {
    label: "Resigned",
    icon: CircleClockIcon,
    color: "text-blue-500",
    iconColor: "#007AFF",
  },
} as const;

export type EmployeeStatus = keyof typeof employeeStatusConfig;
